import { ModelApiService } from './BaseApiService'

export default class SignalRApiService extends ModelApiService {
  constructor() {
    super('SignalR')
  }
}
